export default __webpack_public_path__ + "static/media/mobile-bg.5ff5c69b.jpg";